<template>
    <v-container class="d-flex align-center justify-center" style="min-height: 80vh;">
        <v-card max-width="500" class="text-center pa-8">
            <v-icon size="80" color="success" class="mb-4">
                mdi-check-circle-outline
            </v-icon>
            <v-card-title class="text-h4 mb-2">
                {{ $t('thankYou.thank_you') }}
            </v-card-title>
            <v-card-text class="text-body-1">
                {{ $t('thankYou.your_evaluation_has_been_successfully_submitted') }}
                <br><br>
                {{ $t('thankYou.your_psychologist_will_review') }}
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
  name: 'ThankYouView'
}
</script>

<style scoped>
</style>